import React, { ChangeEvent } from "react";
import { FieldWrapper, FieldLabel, Select } from "./styled";

export const CustomSelect = (props: {
    name: string;
    label: string;
    options: { label: string; value: string }[];
    onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
    value: string;
}) => {
    return (
        <FieldWrapper>
            <FieldLabel htmlFor={props.name}>{props.label}</FieldLabel>
            <Select id={props.name} name={props.name} onChange={props.onChange} value={props.value}>
                <option value="">Show all</option>
                {props.options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Select>
        </FieldWrapper>
    );
};
